const initialState = {
    keycode: '',
    user: {
        _id: null,
        username: '',
        display_name: '',
        bio: '',
        pronouns: '',
        sent_friend_requests: [],
        friend_requests: [],
        friends: [],
        avatar: {
            user_avatar: ''
        },
        token: '',
        push_token: ''
    },
}

export default function chat(state = initialState, action) {
    switch(action.type) {

        case 'SET_KEYCODE':
            return {
                ...state,
                keycode: action.payload
            }

        case 'SET_USER':
            return {
                ...state,
                user: action.payload
            }

        case 'UPDATE_SENT_FRIEND_REQUESTS':
            return {
                ...state,
                user: {
                    ...state.user,
                    sent_friend_requests: action.payload
                }
            } 

        case 'UPDATE_FRIEND_REQUESTS':
            return {
                ...state,
                user: {
                    ...state.user,
                    friend_requests: action.payload
                }
            }    

        default:
            return state    
    }
}